module.exports = __webpack_public_path__ + "media/images/Lock_Shadow_Silver_Unlocked_38@2x-1d5afe8194a53e94025721b59ed6ba0c.png";